

<div class="jumbotron jumbotron-fluid">
  <img src="https://services.ifa.com/art/images/3504_2026-2-23-8-32-49_q60.webp" alt="Notre-Dame Cathedral of Paris" class="jumbotron-background" fetchpriority="high">

  <div class="container">
    <div class="d-flex flex-column align-items-center justify-content-center text-center block">
      <h1 class="display-4 text-center" style="max-width: 800px;">Catholic Values Investments Rooted In Financial Science</h1>
    </div>

    
    <div class="block2">
      <p class="lead">"It must be remembered that the market does not exist in the pure state. It is shaped by the cultural configurations which define it and give it direction." - Pope Emeritus Benedict XVI *</p>
      <p><small style="
        color: white;
        position: relative;
        top: 30px;">
        *This quotation is provided for information purposes only and should not be construed as an endorsement, recommendation or guarantee of any particular financial product, service or advisor.
      </small></p>
    </div>
  </div>
</div>
<section class="riskCapacityHome">
  <div class="container importantNews">
    <div class="row">
      <div class="col-md-12 mt-3 mb-3">
        <h2>What's Your Risk Capacity?</h2>
        <p>Learning your Risk Capacity is the first step to maximizing your expected returns for the risks you take.</p>

        <p>Answer just a few basic questions and you will learn which portfolio captures the right mix of stocks and bonds that is best suited to you so you can effectively grow your money. </p>
        <a routerLink="/survey"><button class="btn btn-primary" style="pointer-events: all; cursor: pointer;">Take Survey</button></a>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 step1 text-center" [routerLink]="['/foundations']">
        <div class="p-3"><fa-icon [icon]="faChurch" size="6x"></fa-icon></div>
        <h2>Foundations & Endowments</h2>
        <p>Reduce the drain of resources and avoid the time-consuming process of manager selection by working with Investing for Catholics.</p>
      </div>
      <div class="col-md-4 step2 text-center" [routerLink]="['/retirement']">
        <div class="p-3"><fa-icon [icon]="faPiggyBank" size="6x"></fa-icon></div>
        <h2>Retirement Plans</h2>
        <p>Investing for Catholics (IFC) offers the highest level of fiduciary protection to meet the unique needs of Catholic institutions.</p>
      </div>
      <div class="col-md-4 step3 text-center" [routerLink]="['/individuals']">
        <div class="p-3"><fa-icon [icon]="faUser" size="6x"></fa-icon></div>
        <h2>Individual Investors</h2>
        <p>At last, investors can enjoy the benefit of passive investing, without sacrificing the integrity of their convictions.</p>
      </div>
    </div>
  </div>

</section>


<section class="appPromo">
  <div class="container">
    <div class="row align-items-center">
      <div class="offset-xl-1 col-xl-8 col-lg-9 col-md-8 mb-3">
        <div class="d-flex align-items-center gap-3 pb-3">
          <a href="https://apps.apple.com/us/app/investing-for-catholics/id6758739546" class="flex-shrink-0">
            <img src="/assets/svg/ifc-app-logo.svg" width="88" height="88" alt="Investing for Catholics app icon" loading="lazy" decoding="async" />
          </a>
          <h2 class="appHeader mb-0">Investing for Catholics App Now Available on the App Store</h2>
        </div>
        <p class="copy">With the app you can:</p>
        <ul class="copy">
          <li>Learn about Catholic Values Investing through charts, articles, and videos.</li>
          <li>Learn about portfolios that align Catholic values with sound financial science.</li>
          <li>Take a no-obligation survey to help you explore different stock-to-bond allocations</li>
        </ul>
        <div class="d-flex flex-wrap align-items-center gap-3 mt-4">
          <a routerLink="/app"><button class="btnLearnMore">Explore the App</button></a>
          <a href="https://apps.apple.com/us/app/investing-for-catholics/id6758739546">
            <img src="/assets/svg/apple-store.svg" width="154" height="50" alt="Download on the App Store" loading="lazy" decoding="async" />
          </a>
        </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 text-center" id="appImage">
        <a routerLink="/app"><img src="https://services.ifa.com/art/images/3517_2026-3-17-12-36-20.png" width="247" height="500" alt="Investing for Catholics app shown on an iPhone" class="img-fluid" loading="lazy" decoding="async" /></a>
      </div>
    </div>
  </div>
</section>

<app-whats-new-articles></app-whats-new-articles>
<section class="whatsNew" id="videos">
  <div class="container">
    <div class="row">

      <div class="col-sm-12">
        <!-- <h3 class="text-center">Latest Videos</h3> -->
        <!-- <div class="card-deck">
          @for (video of videos; track video) {
            <div>
              <app-home-video-card [data]="video"></app-home-video-card>
            </div>
          }
        </div>

        <div class="clearfix"></div> -->

 @if(videos && videos.length>0){
        <h3 class="text-center">Latest Videos</h3>
        <app-banner-slider>       
          @for(video of videos; track video.id) {
          <app-banner-card [class]="'bg-white h380'" [customBody]="true">
            <a class="d-block" routerLink="/videos/{{video.friendlyUrl.toLowerCase()}}">
              @if(video.posterUrl){
                <img loading="lazy" width="285" height="160" src="{{video.posterUrl}}" alt="{{video.title}}">
              }
              @else{
                <img loading="lazy" width="285" height="160" src="{{video.imageUrl}}" alt="{{video.title}}">
              }
            </a>
            <ng-container body>
              <div class="p-3 pt-1">
                <div class="ps-2 pt-0 font-open-1 font-14 text-end">{{video.date | date: "MMMM d, yyyy"}}</div>
                <div class="pt-2">
                  <h3 class="font-open font-18 card-title text-start mb-2"><a class=""
                      routerLink="/videos/{{video.friendlyUrl.toLowerCase()}}">{{video.title}}</a></h3>
                </div>
                <div class="teaser" [innerHTML]="video.teaser">
                </div>
              </div>
            </ng-container>
          </app-banner-card>
          }
        </app-banner-slider>
      }


        <div class="mx-auto text-center mt-5">
          <a routerLink="/videos/" class="btn btn-primary btn-lg mx-auto">All Videos</a>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="clearfix"></div>
<section>
  <div class="container section">
    <div class="row">
      <div class="col-md-9">
        <main>
          <h3>Catholic Values Screened Investments Rooted In Financial Science</h3>
          <p>Investing for Catholics (IFC) provides Catholic Values Investing advice and portfolio implementation to institutions and individuals. Our firm was developed to meet the unique needs of Catholic investors — investing responsibly in line with our Faith while seeking to maximize expected returns for the risks we take.</p>
          <h4>IFC's investment management services are designed for:</h4>
          <ul>
            <li>Catholic organizations such as dioceses and religious institutes</li>
            <li>Foundations and endowments</li>
            <li>Catholic organizational retirement plans, including 401(k), 403(b) and 457 plans</li>
            <li>Catholic healthcare organizations</li>
            <li>Catholic-focused for-profit and non-profit organizations</li>
          </ul>
          <!-- <app-quote-box></app-quote-box> -->
          <p>IFC's investment management services are designed to enable stewards to prudently balance faith-consistent investing with fiduciary best practices.</p>
          <p>Investing for Catholics (IFC) is a division of Index Fund Advisors, Inc. (IFA), a registered investment advisor with the Securities and Exchange Commission<sup>**</sup>, and is based in Irvine, California. IFA is a fee-only advisory firm founded in 1999. IFA has 2,200+ clients located throughout the country and manages $6.02 billion as of December 31, 2025.</p>
          <p><small>** SEC registration does not constitute an endorsement of the firm by the Commission, nor does it indicate that the adviser has attained a particular level of skill or ability.</small></p>
        
          <h3>IFC's Investing Credo</h3>
          <p><strong>Markets Work:</strong> Investing for Catholics bases its research on the widely accepted Efficient Market Hypothesis, the founder of which, Eugene Fama, was awarded the 2013 Nobel Prize in Economics.</p>
          <p><strong>Investing Science Shows the Way:</strong> IFC's Investment strategies are based on principles generally known as Modern Portfolio Theory, and the Fama and French Five-Factor Model for Equities and Two Factor Model for Fixed Income.</p>
          <p><strong>Diversification is Essential:</strong> Portfolios are structured to provide global diversification to include exposure to multiple asset classes within the U.S., International and Emerging Markets, while also including Global Real Estate and Fixed Income.</p>
          <p><strong>Prudent, Faith-Consistent Investing is Possible:</strong> Properly constructed, diversified screened portfolios that include exposures to the Fama-French Factors are expected to vary little in performance from similarly constructed non-screened portfolio.</p>
          <p><strong>Discipline and Patience Should Reward Investors:</strong> Investing for Catholics passive investing strategy seeks to deliver risk appropriate returns in a low-cost, diversified and prudent manner.</p>
        </main>
      </div>
     
      <div class="col-md-3"><div class="text-center mx-auto">
        <img alt="Download Investing for Catholics Brochure" class="mb-5" style="max-width:100%; height:auto; aspect-ratio: 255/330;" width="255" height="330" [lazyLoad]="lazyLoadImage">
        <div class="clearfix"></div>
        <a href="https://www.ifa.com/pdfs/ifc_brochure.pdf" target="_blank" class="btn btn-primary">Download Brochure</a>    

        <div class="m-2 mt-5">
        <form id="newsletterForm" class="newsletter" (ngSubmit)="newsletterFormSubmit()">
          <h4>Sign Up for our Newsletter</h4>
          <p>Receive weekly updates on investing news, charts, and breakdown of top funds.</p>
          @if (newsletterFormSubmit.length>0) {
            <div id="form-messages" class="h3 text-center">{{newsletterFormMessage}}</div>
          }
          @if (!isSending) {
            <div class="hideform">
              <div class="form-group">
                <input [(ngModel)]="name" (blur)="validateName()" type="text" class="form-control" id="name" name="name"
                  placeholder="Name" required="" data-error="Please enter your name" autocomplete="given-name">
                  <div class="error name">{{nameValidationText}}</div>
                </div>
                <div class="form-group">
                  <input [(ngModel)]="email" (blur)="validateEmail()" type="text" placeholder="Email" id="email"
                    class="form-control" name="email" required="" data-error="Please enter your email" autocomplete="email">
                    <div class="error email">{{emailValidationText}}</div>
                  </div>
                  <div class="text-center mt-5 mb-5"><div class="g-recaptcha" data-sitekey="6LdgIHsUAAAAADoZREupxP-6xHArHZS4h7DO4ns3"></div></div>
                  <div class="submit-button text-center">
                    <button class="btn btn-primary" id="submit" type="submit" style="pointer-events: all; cursor: pointer;">Submit</button>
                    <div class="clearfix"></div>
                  </div>
                </div>
              }
            </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>